export default __webpack_public_path__ + "static/media/closedEmail.58c12dde.svg";